import { getImageAuth } from "./imageHeaders";

function toBase64(str) {
  if (!str) return "";
  try {
    return btoa(unescape(encodeURIComponent(str)));
  } catch (e) {
    return "";
  }
}

export const getAuthHeaders = () => {
  const { userId, deviceKey, accessToken } = getImageAuth();

  return {
    "X-User-Id": userId || "",
    "X-Device-Key": deviceKey || "",
    Authorization: accessToken ? `Basic ${toBase64(accessToken)}` : "",
    "X-App-Secret": process.env.REACT_APP_APPSECRET,
  };
};
